import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Section from '../../components/common/Section';

// 定义缺失的样式组件
const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

const FeatureCard = styled.div`
  background-color: white;
  border-radius: ${props => props.theme.borderRadius.medium};
  padding: 1.5rem;
  box-shadow: ${props => props.theme.shadows.small};
  transition: transform ${props => props.theme.transitions.fast};
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: ${props => props.theme.shadows.medium};
  }
`;

const FeatureTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.primary};
`;

const FeatureDescription = styled.p`
  color: ${props => props.theme.colors.lightText};
  line-height: 1.6;
`;

const CDP = () => {
  const { t } = useTranslation();
  
  const features = [
    {
      title: t('products.cdp.features.collection'),
      description: '从网站、移动应用、CRM、电子邮件、社交媒体等各种渠道收集客户数据。'
    },
    {
      title: t('products.cdp.features.profile'),
      description: '创建360度客户视图，整合身份、行为、交易和偏好数据。'
    },
    {
      title: t('products.cdp.features.segmentation'),
      description: '基于多维度属性和行为，创建精细的客户细分。'
    },
    {
      title: t('products.cdp.features.activation'),
      description: '将客户数据和洞察激活到各种营销和服务渠道。'
    },
    {
      title: t('products.cdp.features.privacy'),
      description: '内置隐私管理功能，确保符合GDPR、CCPA等隐私法规。'
    }
  ];
  
  return (
    <>
      <Section 
        title={t('products.cdp.title')} 
        subtitle={t('products.cdp.subtitle')}
      >
        <p>{t('products.cdp.content')}</p>
        
        <FeatureGrid>
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeatureGrid>
      </Section>
    </>
  );
};

export default CDP;